// apps screens' English text (D146). Keys start with "apps.".
export const apps = {
  // Shared by the family apps
  'apps.shared.theFamily': 'the family',
  'apps.shared.family': 'Family',
  'apps.shared.moreFor': 'More for {name}',
  'apps.shared.closeSearch': 'Close search',
  'apps.shared.nothingHere': 'Nothing here',
  'apps.shared.keepIt': 'Keep it',
  'apps.shared.today': 'Today',
  'apps.shared.unknownError': 'Unknown error',

  // Documents
  'apps.documents.filter.all': 'All',
  'apps.documents.filter.photos': 'Photos',
  'apps.documents.filter.pdfs': 'PDFs',
  'apps.documents.filter.videos': 'Videos',
  'apps.documents.filter.other': 'Other',
  'apps.documents.fileTile': 'FILE',
  'apps.documents.today': 'today',
  'apps.documents.yesterday': 'yesterday',
  'apps.documents.upload': 'Upload a file',
  'apps.documents.loadFailed': 'Could not load documents',
  'apps.documents.saveFailed': 'Could not save',
  'apps.documents.openFailed': 'Could not open the file',
  'apps.documents.added': 'Added to Documents',
  'apps.documents.uploadFailed': 'Could not upload',
  'apps.documents.deleted': 'File deleted',
  'apps.documents.deleteFailed': 'Could not delete the file',
  'apps.documents.search': 'Search documents',
  'apps.documents.listView': 'Switch to list view',
  'apps.documents.gridView': 'Switch to grid view',
  'apps.documents.download': 'Download',
  'apps.documents.folderTags': 'Folder & tags…',
  'apps.documents.deleteMenu': 'Delete…',
  'apps.documents.filterLabel': 'Filter documents',
  'apps.documents.folders': 'Folders',
  'apps.documents.allFolders': 'All folders',
  'apps.documents.loading': 'Loading the family’s documents…',
  'apps.documents.emptyTitle': 'No documents yet',
  'apps.documents.emptyBody':
    'Upload a file, or save one from any chat. Everyone in {family} will be able to open it.',
  'apps.documents.noMatch': 'No documents match. Try another filter or search.',
  'apps.documents.open': 'Open {name}',
  'apps.documents.deleteTitle': 'Delete this file?',
  'apps.documents.deleteBody':
    'It will be removed from Documents for everyone in {family}. You can’t undo this.',
  'apps.documents.addedBy': 'Added by {name}',
  'apps.documents.deleteConfirm': 'Delete for everyone',

  // Document details (folder, tags, note)
  'apps.documentDetails.folder': 'Folder',
  'apps.documentDetails.folderPlaceholder': 'House, School, Travel…',
  'apps.documentDetails.folderHint': 'Leave empty to keep it out of folders.',
  'apps.documentDetails.tags': 'Tags',
  'apps.documentDetails.tagsPlaceholder': 'tax, 2026',
  'apps.documentDetails.tagsHint':
    'Separate with commas. Search finds documents by tag.',
  'apps.documentDetails.note': 'Note',
  'apps.documentDetails.notePlaceholder': 'What it is, when it expires…',

  // Links
  'apps.links.loadFailed': 'Could not load links',
  'apps.links.search': 'Search links',
  'apps.links.alreadySaved': 'Already in Links',
  'apps.links.shared': 'Link shared with the family',
  'apps.links.saveFailed': 'Could not save the link',
  'apps.links.removed': 'Link removed',
  'apps.links.removeFailed': 'Could not remove the link',
  'apps.links.copied': 'Link copied',
  'apps.links.copyFailed': 'Could not copy',
  'apps.links.open': 'Open',
  'apps.links.copy': 'Copy link',
  'apps.links.removeMenu': 'Remove…',
  'apps.links.paste': 'Paste a link to share',
  'apps.links.add': 'Add',
  'apps.links.loading': 'Loading the family’s links…',
  'apps.links.emptyTitle': 'No links yet',
  'apps.links.noMatch': 'No links match that search.',
  'apps.links.emptyBody':
    'Paste a link above, or save one from any chat. Everyone in {family} will see it here.',
  'apps.links.thisWeek': 'This week',
  'apps.links.earlier': 'Earlier',
  'apps.links.removeTitle': 'Remove this link?',
  'apps.links.removeBody':
    'It will be removed from Links for everyone in {family}. The message it came from stays in its chat.',
  'apps.links.addedBy': 'Added by {name}',
  'apps.links.removeConfirm': 'Remove for everyone',

  // Lists
  'apps.lists.justNow': 'just now',
  'apps.lists.minutesAgo': '{count} min ago',
  'apps.lists.hoursAgo': '{count} h ago',
  'apps.lists.removeTemplateFailed': 'Could not remove the template',
  'apps.lists.newList': 'New list',
  'apps.lists.loadFailed': 'Could not load lists',
  'apps.lists.createFailed': 'Could not create the list',
  'apps.lists.deleted': 'List deleted',
  'apps.lists.deleteFailed': 'Could not delete the list',
  'apps.lists.deleteMenu': 'Delete list…',
  'apps.lists.loading': 'Loading the family’s lists…',
  'apps.lists.emptyTitle': 'No lists yet',
  'apps.lists.emptyBody':
    'Start the grocery list, or one for a trip. Everyone in {family} can add to it and tick things off.',
  'apps.lists.progressCount': '{checked} of {total}',
  'apps.lists.progressLabel': '{name} progress',
  'apps.lists.updated': '{name} · updated {when}',
  'apps.lists.allDone': 'All {count} done',
  'apps.lists.startFrom': 'Start from',
  'apps.lists.blank': 'Blank',
  'apps.lists.removeTemplate': 'Remove template {name}',
  'apps.lists.name': 'Name',
  'apps.lists.namePlaceholder': 'Groceries, Winter trip packing…',
  'apps.lists.create': 'Create list',
  'apps.lists.deleteTitle': 'Delete “{name}”?',
  'apps.lists.deleteBodyOne':
    'The list and its {count} item go for everyone in {family}. You can’t undo this.',
  'apps.lists.deleteBodyOther':
    'The list and all {count} items go for everyone in {family}. You can’t undo this.',
  'apps.lists.deleteConfirm': 'Delete list',
  'apps.lists.repeat.daily': 'Every day',
  'apps.lists.repeat.weekly': 'Every week',
  'apps.lists.repeat.monthly': 'Every month',
  'apps.lists.due.today': 'Today',
  'apps.lists.due.tomorrow': 'Tomorrow',
  'apps.lists.due.yesterday': 'Yesterday',
  'apps.lists.due.overdue': 'Overdue · {day}',

  // A list's checklist
  'apps.listDetail.forYou': 'For you',
  'apps.listDetail.addedByYou': 'Added by you',
  'apps.listDetail.forName': 'For {name}',
  'apps.listDetail.addedByName': 'Added by {name}',
  'apps.listDetail.someone': 'someone',
  'apps.listDetail.detailsFor': 'Details for {text}',
  'apps.listDetail.detailsMenu': 'Details…',
  'apps.listDetail.reorder': 'Reorder {text}',
  'apps.listDetail.loadFailed': 'Could not load this list',
  'apps.listDetail.addFailed': 'Could not add item',
  'apps.listDetail.updateFailed': 'Could not update item',
  'apps.listDetail.removeFailed': 'Could not remove item',
  'apps.listDetail.saveFailed': 'Could not save the item',
  'apps.listDetail.templateSaved': 'Saved as a template',
  'apps.listDetail.templateSavedHint':
    'Pick it under New list to start a fresh copy.',
  'apps.listDetail.templateFailed': 'Could not save the template',
  // M76 (D328): opened from an older (v1) envelope, not bound to its row.
  'apps.record.unbound': 'Older entry · not verified',
  'apps.listDetail.clearedOne': 'Cleared {count} item',
  'apps.listDetail.clearedOther': 'Cleared {count} items',
  'apps.listDetail.clearFailed': 'Could not clear checked items',
  'apps.listDetail.reorderFailed': 'Could not reorder item',
  'apps.listDetail.renameFailed': 'Could not rename list',
  'apps.listDetail.deleteFailed': 'Could not delete list',
  'apps.listDetail.loading': 'Loading the list…',
  'apps.listDetail.notFound': 'List not found',
  'apps.listDetail.backToLists': 'Back to lists',
  'apps.listDetail.options': 'List options',
  'apps.listDetail.saveTemplate': 'Save as template',
  'apps.listDetail.rename': 'Rename list',
  'apps.listDetail.progress': 'Progress',
  'apps.listDetail.empty':
    'Nothing on this list yet. Add the first thing below.',
  'apps.listDetail.doneCount': 'Done · {count}',
  'apps.listDetail.clearDone': 'Clear done',
  'apps.listDetail.itemDone': '{text}, done',
  'apps.listDetail.addPlaceholder': 'Add an item',
  'apps.listDetail.addButton': 'Add item',
  'apps.listDetail.listName': 'List name',
  'apps.listDetail.deleteBodyOne':
    'The list and its {count} item go for the whole family. You can’t undo this.',
  'apps.listDetail.deleteBodyOther':
    'The list and all {count} items go for the whole family. You can’t undo this.',

  // An item's details sheet
  'apps.listItem.lastDoneBy': 'Last done by {name}, {date}',
  'apps.listItem.lastDoneByYou': 'Last done by you, {date}',
  'apps.listItem.title': 'Item details',
  'apps.listItem.item': 'Item',
  'apps.listItem.note': 'Note',
  'apps.listItem.notePlaceholder': '2 kg, the blue one…',
  'apps.listItem.for': 'For',
  'apps.listItem.anyone': 'Anyone',
  'apps.listItem.me': 'Me',
  'apps.listItem.due': 'Due',
  'apps.listItem.noDate': 'No date',
  'apps.listItem.tomorrow': 'Tomorrow',
  'apps.listItem.dueDate': 'Due date',
  'apps.listItem.repeats': 'Repeats',
  'apps.listItem.never': 'Never',
  'apps.listItem.repeatHint':
    'Ticking it moves it to the next date instead of finishing it.',
  'apps.listItem.delete': 'Delete item',

  // Starred
  'apps.starred.photo': 'Photo',
  'apps.starred.video': 'Video',
  'apps.starred.voice': 'Voice note',
  'apps.starred.file': 'File',
  'apps.starred.loadFailed': 'Could not load starred messages',
  'apps.starred.loadMoreFailed': 'Could not load more',
  'apps.starred.unstarFailed': 'Could not unstar message',
  'apps.starred.everyone': 'Everyone',
  'apps.starred.directMessage': 'Direct message',
  'apps.starred.search': 'Search starred',
  'apps.starred.title': 'Starred',
  'apps.starred.onlyYou': 'Only you can see these',
  'apps.starred.loading': 'Loading your starred messages…',
  'apps.starred.emptyTitle': 'Nothing starred yet',
  'apps.starred.emptyBody':
    'Press and hold a message and choose Star to keep it here: recipes, addresses, dates. Only you can see your stars.',
  'apps.starred.unknown': 'Unknown',
  'apps.starred.unstar': 'Unstar',
  'apps.starred.openIn': 'Open in {chat}',
  'apps.starred.showMore': 'Show more',
} as const;
